<script setup lang="ts">
import ProjectCard from '@/pages/banks/ProjectCard.vue'
import ProjectList from '@/pages/banks/ProjectList.vue'
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import ProjectSuggestionData = App.Data.Bank.ProjectSuggestionData

const { t } = useI18n()

const props = defineProps<{
  active_projects: Array<ProjectSuggestionData>
}>()

const viewOptions = [
  { label: t('views.table'), value: 'table' },
  { label: t('views.cards'), value: 'cards' },
]
const selectedView = ref('table')

const translatedProjectSuggestionData = computed(() => {
  return props.active_projects.map(
    (projectSuggestion) =>
      ({
        ...projectSuggestion,
        estate_objects: projectSuggestion.estate_objects.map((eo) => ({
          ...eo,
          estate_object_type: t(`enums.estateObjectType.${eo.estate_object_type}`),
          owner_type: t(`enums.personType.${eo.owner_type}`),
        })),
      }) as ProjectSuggestionData,
  )
})
</script>

<template>
  <Card>
    <template #title>
      <div class="flex flex-col gap-4">
        <h2>{{ t('title') }}</h2>
        <SelectButton v-model="selectedView" :options="viewOptions" option-label="label" option-value="value" />
      </div>
    </template>
    <template #content>
      <ProjectList
        v-if="selectedView === 'table'"
        :projects="translatedProjectSuggestionData"
        in-negotiations
        :actions="{
          details: true,
        }" />
    </template>
  </Card>
  <div v-if="selectedView === 'cards'" class="flex flex-col gap-4">
    <Card v-if="translatedProjectSuggestionData.length === 0">
      <template #content>
        {{ t('empty') }}
      </template>
    </Card>
    <Card
      v-for="suggestion in translatedProjectSuggestionData"
      :key="suggestion.id"
      :pt="{ content: { class: 'w-full' } }">
      <template #content>
        <ProjectCard
          :project="suggestion"
          in-negotiations
          :actions="{
            details: true,
          }" />
      </template>
    </Card>
  </div>
</template>

<i18n>
{
    "en": {
        "views": {
            "table": "Table View",
            "cards": "Card View"
        },
        "title": "Active projects",
        "empty": "No project suggestions available."
    },
    "de": {
        "views": {
            "table": "Tabellenansicht",
            "cards": "Kartenansicht"
        },
        "title": "In Finanzierungsverhandlung",
        "empty": "Keine Finanzierungsverhandlung aktiv."
    }
}
</i18n>
